//@ts-expect-error Untyped file
import * as json from './json';
export const getReportJson = report => {
  return json.encode(json.stringify(report));
};